import { fetchDesignation } from 'redux/services/designation'
import { RootState, TypedDispatch } from 'redux/store'
import { getAnalyticsInstance } from '../analytics'

interface TrackBeginCheckoutParams {
  currency: string
  frequency: string
  value: number
  dispatch: TypedDispatch<RootState>
  campaignId: string
  campaignName: string
  organizationId: number
  organizationName: string
  designationId: number
}

export const trackBeginCheckoutEvent = async (params: TrackBeginCheckoutParams) => {
  const analytics = getAnalyticsInstance()

  const items = await createCheckoutItemsArray(
    params.dispatch,
    params.designationId,
    params.frequency,
    params.value,
  )

  const payload = {
    action: 'checkout',
    currency: params.currency,
    value: params.value,
    items,
    campaign_id: params.campaignId,
    campaign_name: params.campaignName,
    organization_id: params.organizationId,
    organization_name: params.organizationName,
  }

  analytics.track('begin_checkout', payload)
}

const createCheckoutItemsArray = async (
  dispatch: TypedDispatch<RootState>,
  designationId: number,
  frequency: string,
  value: number,
) => {
  const designation = await dispatch(fetchDesignation.initiate({ designationId })).unwrap()

  return [
    {
      item_id: `donation_${designationId}`,
      item_category: 'donation',
      item_category2: designationId,
      item_category3: designation.name,
      item_category4: frequency,
      quantity: 1,
      price: value,
      fundraising_page_id: undefined,
      fundraising_team_id: undefined,
    },
  ]
}
